<template>
  <el-backtop
    :visibility-height="visibilityHeight"
    :right="right"
    :bottom="bottom"
    class="custom-backtop"
  />
</template>

<script>
export default {
  name: "mobile_BackToTop",
  props: {
    visibilityHeight: {
      type: Number,

      default: window.innerWidth * 0.53,
    },
    right: {
      type: Number,

      default: window.innerWidth * 0.06,
    },
    bottom: {
      type: Number,

      default: window.innerWidth * 0.33,
    },
  },
};
</script>

<style scoped>
/* 基础样式 */
.custom-backtop {
  --size: 11.73vw; /* 控制按钮容器大小 */
  width: var(--size);
  height: var(--size);
  font-size: 7vw; /* 控制箭头大小 */
  background: #ffffff; /* 默认背景色 */
  color: #05358c; /* 文字颜色 */
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}

/* 悬停效果 */
.backtop-content:active {
  background: #9ca3af; /* 点击背景色 */
  transform: scale(1.1);
}
</style>